import { User } from '@/types/core/User';
import { MemberStatus } from '@/types/enum/MemberStatus';
import { Role } from '@/types/enum/Role';

const ROLE_TO_EXCLUDE = 'ROLE_USER';

const roleToMemberStatus = (role: string): MemberStatus | undefined => {
  const mapping: Record<Role, MemberStatus> = {
    [Role.PARTNER]: MemberStatus.PARTNER,
    [Role.COUNTRY_ORGANISER]: MemberStatus.COUNTRY_ORGANISER,
    [Role.WORLD_ORGANISER]: MemberStatus.WORLD_ORGANISER,
    [Role.MEMBER]: MemberStatus.MEMBER,
  };

  return mapping[role];
};

export function humanizedUserRole(user: User): MemberStatus | undefined {
  const role = user.roles?.find(role => role !== ROLE_TO_EXCLUDE);

  return role !== undefined ? roleToMemberStatus(role) : undefined;
}
